import axios from 'axios'
import { Message } from 'element-ui'

axios.defaults.withCredentials=true;//允许使用cookie

const service = axios.create({
  // 支持通过环境变量切换后端地址：.env.development / .env.production
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://8.141.15.215:8081",
  timeout: 600000
})

service.interceptors.request.use((config) => {
  try {
    const token = window && window.localStorage ? window.localStorage.getItem('ADMIN_TOKEN') : ''
    if (token) {
      config.headers = config.headers || {}
      config.headers['X-Admin-Token'] = token
    }
  } catch (e) {
    // ignore
  }
  return config
})

service.interceptors.response.use(
  (res) => res,
  (error) => {
    const msg =
      (error && error.response && error.response.data && (error.response.data.message || error.response.data.msg)) ||
      (error && error.message) ||
      '请求失败'
    Message.error(msg)
    return Promise.reject(error)
  }
)
export default service
